import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { NoMatch } from "../src/pages/NoMatch";

import Chunk_default from "./default";
export default function SplitPagesIndex() {
  return (
    <Switch>
      <Route path="/admin" exact>
        <Redirect to="/admin/booking/Dashboard" />
      </Route>
      ,
      <Route path="/" exact>
        <Redirect to="/utilities/Dashboard" />
      </Route>
      ,
      <Route path="/dev" exact>
        <Redirect to="/dev/Accounts" />
      </Route>
      ,
      <Route path="/accounts" exact>
        <Redirect to="/dev/Accounts" />
      </Route>
      <Route path="/">
        <Chunk_default />
      </Route>
      <Route path="*">
        <NoMatch />
      </Route>
    </Switch>
  );
}
